module.exports = __webpack_public_path__ + "img/cv.ac9da5f8.svg";